import { MODALS } from 'common/domain/constants';
import { STATES } from 'common/domain/states';
import { LOANS, LOANS_MODAL_STATES } from 'loans.module/common/domain/constants.loans';

class MyLoansContextMenuController {
  constructor($state, EventEmitter, $window, LoansUserDataService) {
    'ngInject';
    this.state = $state;
    this.EventEmitter = EventEmitter;
    this.window = $window;
    this.isMobileApp = $window.innerWidth < 1024;
    this.loansUserDataService = LoansUserDataService;
    this.seniorUser = this.loansUserDataService.getSenior();
  }

  get modal() {
    return $(MODALS.MY_LOANS);
  }

  openModal(option) {
    if (this.isCadastralModalWithServiceClosed(option)) {
      return;
    }
    const isCadastralReference =
      option === LOANS_MODAL_STATES.CADASTRAL_REFERENCE;
    let dataCadastral = isCadastralReference
      ? this._getDataCadastralReference()
      : undefined;
    this.onChangeOptionSelected(
      this.EventEmitter({
        optionSelected: option,
        dataCadastral: dataCadastral
      })
    );

    if (!isCadastralReference || !this.isMobileApp) {
      this.modal.modal({ backdrop: 'static', keyboard: false });
    }
  }

  _getDataCadastralReference() {
    if (this.isMobileApp) {
      return {
        loan: this.loan,
        tempLoanObject: this.tempLoanObject
      };
    }
  }

  isCadastralModalWithServiceClosed(option) {
    const isModalCadastral = option === LOANS_MODAL_STATES.CADASTRAL_REFERENCE;
    const isEmptyCadastralReference =
      Object.keys(this.loan.cadastralReference).length === 0;
    return isModalCadastral && isEmptyCadastralReference && this.serviceClosed;
  }

  showAmortization() {
    return (
      this.statusCode === LOANS.STATES.ID.IN_FORCE &&
      !this.serviceClosed &&
      this.loan.amortizable
    );
  }

  openAmortization() {
    this.state.go(STATES.LOANS.REPAYMENT, { loan: this.loan });
  }

  showFiscalInformation() {
    if (this.isMobileApp || this.seniorUser) return false;
    return (
      this.statusCode === LOANS.STATES.ID.IN_FORCE ||
      this.statusCode === LOANS.STATES.ID.NOT_IN_FORCE
    );
  }

  showReferenceCatastral() {
    const statusCatastral =
      this.statusCode === LOANS.STATES.ID.AUTHORIZED ||
      this.statusCode === LOANS.STATES.ID.IN_FORCE ||
      this.statusCode === LOANS.STATES.ID.NOT_IN_FORCE ||
      this.statusCode === LOANS.STATES.ID.PENDING ||
      this.statusCode === LOANS.STATES.ID.SUBSCRIBER ||
      this.statusCode === LOANS.STATES.ID.PENDING_SIGNATURE;

    const loansAuthorized =
      this.loan.modalityCode === LOANS.ID_HR.SOCIAL_HOUSING_LOAN ||
      this.loan.modalityCode === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN;

    if (this.statusCode === LOANS.STATES.ID.NOT_IN_FORCE) {
      return (
        loansAuthorized &&
        this.isDateCancellationHigher &&
        this.isDateGrantHigher
      );
    }

    return statusCatastral && loansAuthorized;
  }

  showViewReceipts() {
    if (this.isMobileApp || this.seniorUser) return false;
    return (
      this.statusCode === LOANS.STATES.ID.IN_FORCE ||
      this.statusCode === LOANS.STATES.ID.NOT_IN_FORCE
    );
  }

  showViewPolicy() {
    if (this.isMobileApp || this.seniorUser) return false;
    const showByStatus =
      this.statusCode === LOANS.STATES.ID.AUTHORIZED ||
      this.statusCode === LOANS.STATES.ID.NOT_IN_FORCE ||
      this.statusCode === LOANS.STATES.ID.IN_FORCE ||
      this.statusCode === LOANS.STATES.ID.SUBSCRIBER;
    const showByLoanId =
      this.loan.modalityCode !== LOANS.ID_HR.FIVE_MONTH &&
      this.loan.modalityCode !== LOANS.ID_HR.NINE_MONTH;
    return showByStatus && showByLoanId;
  }

  showRequestNovation(){
    return this.loan.novationCollective || this.loan.novationTypeVariable;
  }

  openLink(link) {
    this.window.open(link, '_blank');
  }
}

export default MyLoansContextMenuController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansContextMenu/myLoansContextMenu.controller.js